'use client';

import { useTranslation } from '@/core/components/providers/TranslationProvider';

/** WCAG 2.4.1 — first Tab stop on every storefront page, jumps past header and navigation. */
export function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[10000] focus:rounded-lg focus:bg-white focus:px-4 focus:py-3 focus:text-sm focus:font-semibold focus:text-slate-900 focus:shadow-lg"
    >
      {t('a11y.skip_to_content', 'Przejdź do treści')}
    </a>
  );
}
